import { FloatButton } from "antd";
import { useDispatch } from "react-redux";
import { showLessFor } from "../../store/recordTables/actions";


const FloatingButton = props => {
    const dispatch = useDispatch();


  const target = props?.target ?? '';

  const handleClick = () => {
    console.debug("clicked see less of ", target);
    dispatch(showLessFor(target))
  }

  return (<FloatButton
          // icon={<FileTextOutlined />}
          description={props?.description ?? ''}
          shape="square"
          style={{
            right: 24,
          }}
          onClick={handleClick}
        />

  );
};

export default FloatingButton;
